import React from 'react';
import colorLogo from 'V2/Shared/Assets/logo-color.svg';
import { Lock } from 'V2/Shared/Icons/Lock';
import styles from './styles.module.css';

export const CheckoutPageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className={styles.pageRoot}>
    <div className={styles.pageHeader}>
      <img src={colorLogo} alt="Clearcover" className={styles.pageLogo} />
      <span className={styles.secureLabel}>
        <Lock color="#4d5258" /> Secure-checkout
      </span>
    </div>
    <div className={styles.pageContent}>{children}</div>
  </div>
);
